(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barra-cronometro-promo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(seccion) {
      var raiz = seccion;
      if (!raiz) return;

      var fecha = raiz.getAttribute('data-fecha-fin');
      var hora = raiz.getAttribute('data-hora-fin') || '00:00';
      var ocultar = raiz.getAttribute('data-ocultar-al-finalizar') === 'true';

      if (!fecha) return;

      var objetivo = new Date(fecha + 'T' + hora + ':00').getTime();
      if (isNaN(objetivo)) return;

      var diaDecena = raiz.querySelector('[data-dia-decena]');
      var diaUnidad = raiz.querySelector('[data-dia-unidad]');
      var horaDecena = raiz.querySelector('[data-hora-decena]');
      var horaUnidad = raiz.querySelector('[data-hora-unidad]');
      var minDecena = raiz.querySelector('[data-min-decena]');
      var minUnidad = raiz.querySelector('[data-min-unidad]');
      var segDecena = raiz.querySelector('[data-seg-decena]');
      var segUnidad = raiz.querySelector('[data-seg-unidad]');

      function pintar(valor, decena, unidad) {
        var texto = valor < 10 ? '0' + valor : '' + valor;
        if (texto.length > 2) {
          decena.textContent = texto.slice(0, texto.length - 1);
          unidad.textContent = texto.slice(-1);
        } else {
          decena.textContent = texto.charAt(0);
          unidad.textContent = texto.charAt(1);
        }
      }

      var intervalo = setInterval(function () {
        var ahora = new Date().getTime();
        var resto = objetivo - ahora;

        if (resto <= 0) {
          clearInterval(intervalo);
          pintar(0, diaDecena, diaUnidad);
          pintar(0, horaDecena, horaUnidad);
          pintar(0, minDecena, minUnidad);
          pintar(0, segDecena, segUnidad);
          if (ocultar) {
            raiz.style.display = 'none';
          }
          return;
        }

        var dias = Math.floor(resto / (1000 * 60 * 60 * 24));
        var horas = Math.floor((resto % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutos = Math.floor((resto % (1000 * 60 * 60)) / (1000 * 60));
        var segundos = Math.floor((resto % (1000 * 60)) / 1000);

        pintar(dias, diaDecena, diaUnidad);
        pintar(horas, horaDecena, horaUnidad);
        pintar(minutos, minDecena, minUnidad);
        pintar(segundos, segDecena, segUnidad);
      }, 1000);
    }

    function iniciarTodas() {
      var secciones = document.querySelectorAll('.bcp-cronometro');
      for (var i = 0; i < secciones.length; i++) {
        iniciar(secciones[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iconos-confianza"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBeneficios(seccion) {
      var track = seccion.querySelector('[data-beneficios-iconos-track]');
      var puntosWrap = seccion.querySelector('[data-beneficios-iconos-puntos]');
      if (!track || !puntosWrap) return;

      var slides = track.querySelectorAll('[data-beneficios-iconos-slide]');
      var puntos = puntosWrap.querySelectorAll('[data-beneficios-iconos-punto]');
      if (!slides.length || !puntos.length) return;

      var mql = window.matchMedia('(min-width: 990px)');
      var indiceActual = 0;
      var ticking = false;

      function setActivo(indice) {
        if (indice === indiceActual) return;
        indiceActual = indice;
        for (var i = 0; i < puntos.length; i++) {
          if (i === indice) {
            puntos[i].classList.add('beneficios-iconos-punto--activo');
          } else {
            puntos[i].classList.remove('beneficios-iconos-punto--activo');
          }
        }
      }

      function calcularIndice() {
        var centro = track.scrollLeft + (track.clientWidth / 2);
        var masCercano = 0;
        var menorDistancia = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var slideCentro = slides[i].offsetLeft + (slides[i].offsetWidth / 2);
          var distancia = Math.abs(slideCentro - centro);
          if (distancia < menorDistancia) {
            menorDistancia = distancia;
            masCercano = i;
          }
        }
        setActivo(masCercano);
      }

      function onScroll() {
        if (mql.matches) return;
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          calcularIndice();
          ticking = false;
        });
      }

      function irA(indice) {
        var slide = slides[indice];
        if (!slide) return;
        var destino = slide.offsetLeft - ((track.clientWidth - slide.offsetWidth) / 2);
        track.scrollTo({ left: destino, behavior: 'smooth' });
      }

      track.addEventListener('scroll', onScroll, { passive: true });

      for (var i = 0; i < puntos.length; i++) {
        (function (indice) {
          puntos[indice].addEventListener('click', function () {
            irA(indice);
          });
        })(i);
      }

      calcularIndice();
    }

    function initTodos() {
      var secciones = document.querySelectorAll('[data-beneficios-iconos]');
      for (var i = 0; i < secciones.length; i++) {
        initBeneficios(secciones[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTodos);
    } else {
      initTodos();
    }

    document.addEventListener('shopify:section:load', function (evento) {
      var seccion = evento.target.querySelector('[data-beneficios-iconos]');
      if (seccion) initBeneficios(seccion);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prueba-moonkie"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBannersPromo(seccion) {
      var track = seccion.querySelector('[data-banners-promo-track]');
      var puntosWrap = seccion.querySelector('[data-banners-promo-puntos]');
      if (!track || !puntosWrap) return;

      var slides = track.querySelectorAll('[data-banners-promo-slide]');
      var puntos = puntosWrap.querySelectorAll('[data-banners-promo-punto]');
      if (!slides.length || !puntos.length) return;

      var mql = window.matchMedia('(min-width: 990px)');
      var indiceActual = 0;
      var ticking = false;

      function setActivo(indice) {
        if (indice === indiceActual) return;
        indiceActual = indice;
        for (var i = 0; i < puntos.length; i++) {
          if (i === indice) {
            puntos[i].classList.add('banners-promo-punto--activo');
          } else {
            puntos[i].classList.remove('banners-promo-punto--activo');
          }
        }
      }

      function calcularIndice() {
        var centro = track.scrollLeft + (track.clientWidth / 2);
        var masCercano = 0;
        var menorDistancia = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var slideCentro = slides[i].offsetLeft + (slides[i].offsetWidth / 2);
          var distancia = Math.abs(slideCentro - centro);
          if (distancia < menorDistancia) {
            menorDistancia = distancia;
            masCercano = i;
          }
        }
        setActivo(masCercano);
      }

      function onScroll() {
        if (mql.matches) return;
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          calcularIndice();
          ticking = false;
        });
      }

      function irA(indice) {
        var slide = slides[indice];
        if (!slide) return;
        var destino = slide.offsetLeft - ((track.clientWidth - slide.offsetWidth) / 2);
        track.scrollTo({ left: destino, behavior: 'smooth' });
      }

      track.addEventListener('scroll', onScroll, { passive: true });

      for (var i = 0; i < puntos.length; i++) {
        (function (indice) {
          puntos[indice].addEventListener('click', function () {
            irA(indice);
          });
        })(i);
      }

      calcularIndice();
    }

    function initTodos() {
      var secciones = document.querySelectorAll('[data-banners-promo]');
      for (var i = 0; i < secciones.length; i++) {
        initBannersPromo(secciones[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTodos);
    } else {
      initTodos();
    }

    document.addEventListener('shopify:section:load', function (evento) {
      var seccion = evento.target.querySelector('[data-banners-promo]');
      if (seccion) initBannersPromo(seccion);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
